















































































import { mapState } from 'vuex';
import { Dialog } from '@zyf2e/capui-mobile';

import { SearchPlaceholderBar } from '@/components/SearchBox';
import { goto } from '@/utils';
import { SPECIALIST, USER, HOSPITAL_LIST } from '@/constant';
import {
  dispatchGetHomePageInfo,
  commitSetSearchText,
  commitSetSearchHistory,
  commitClearSearchHistory,
  dispatchGetRecommendSpecialists
} from '@/store/specialist';
import { IspecialistDetail, IgetClinicHomePageHolder, IgetClinicHomePageContent } from '@/store/specialist/index.d';

import Search from '@/pages/SpecialistClinic/components/search.vue';

import Component from 'vue-class-component';
import { commitSetRiskBookAgreed } from '@/store/user';
import { commitRemoveKeepAliveItem } from '@/store/global';
import riskbook from '@/pages/SpecialistClinic/riskbook';
import Webview from '@/webview';

enum PLACERHOLDER_TYPE_ENUM {
  BANNERS = 'ZYJK001',
  DEPARTMENTS = 'ZYJK027'
}

type Holder = { [key: string]: Partial<IgetClinicHomePageHolder> };

@Component({
  name: 'Home',
  components: {
    SearchPlaceholderBar,
    Search
  },
  computed: {
    ...mapState(SPECIALIST, ['searchHistory', 'searchText']),
    ...mapState(USER, ['riskBookAgreed'])
  }
})
export default class SpeicalistClinic extends Webview {
  showSearch = false;

  homePag: Holder = {
    [PLACERHOLDER_TYPE_ENUM.BANNERS]: {},
    [PLACERHOLDER_TYPE_ENUM.DEPARTMENTS]: {}
  };

  recommendSpecialists: IspecialistDetail[] = [];

  searchHistory!: string[];

  searchText!: string;

  riskBookAgreed!: boolean;

  riskbook = riskbook;

  PLACERHOLDER_TYPE_ENUM = PLACERHOLDER_TYPE_ENUM;

  async created() {
    commitSetSearchText(this.$store, '');

    this.ZYToast.setOnceConfig({ manual: true });

    const { holderList } = await dispatchGetHomePageInfo(this.$store).catch(() => ({ holderList: [] }));

    this.ZYToast.close();

    this.homePag = (holderList as IgetClinicHomePageHolder[]).reduce((prevsious, holder) => {
      return {
        ...prevsious,
        [holder.holderCode]: holder
      };
    }, {} as Holder);

    this.registFunc({
      type: 'home',
      func: this.getList
    });
    this.getList();

    // this.recommendSpecialists = recommendDoctors;
  }

  async getList() {
    const { recommendDoctors = [] } = await dispatchGetRecommendSpecialists(this.$store, {
      areaName: this.location
    }).catch(() => ({ recommendDoctors: [] }));
    this.recommendSpecialists = recommendDoctors;
  }

  handleSearch(searchText: string) {
    if (!searchText) {
      return;
    }
    commitSetSearchText(this.$store, searchText);
    commitSetSearchHistory(this.$store, searchText);
    this.toSearchPage();
  }

  handleSelect(searchText: string) {
    commitSetSearchText(this.$store, searchText);
    commitSetSearchHistory(this.$store, searchText);
    this.toSearchPage();
  }

  async handleDel() {
    try {
      await Dialog.confirm({
        title: '确定删除历史记录',
        message: '删除后记录将全部清除，确定删除吗？'
      });

      commitClearSearchHistory(this.$store);
    } catch (err) {
      // do nothing
    }
  }

  toSearchPage() {
    this.$router.push('/doctor-search');
  }

  agreeRiskBook() {
    commitSetRiskBookAgreed(this.$store, true);
  }

  jumpUrl({ h5Href, h5HrefType = '' }: IgetClinicHomePageContent) {
    goto.bind(this)({
      type: h5HrefType,
      url: h5Href
    });
  }

  linkHospitalList() {
    this.$router.push(HOSPITAL_LIST);
  }

  bannerTrack(content: IgetClinicHomePageContent, index: number) {
    this.telescope.trackEvent({
      trackId: [this.constant.CLICK_EXPERT_CONSULTATION_BANNER1, this.constant.CLICK_EXPERT_CONSULTATION_BANNER2][index]
    });

    this.jumpUrl(content);
  }

  departmentTrack(content: IgetClinicHomePageContent) {
    this.telescope.trackEvent({
      trackId:
        content.h5Href === this.constant.DEPARTMENT_SEARCH
          ? this.constant.CLICK_EXPERT_CONSULTATION_ALL_DEPARTMENT
          : this.constant.CLICK_EXPERT_CONSULTATION_DEPARTMENT,
      custom: {
        url: content.h5Href
      }
    });
    commitRemoveKeepAliveItem(this.$store, 'DoctorSearch');
    this.jumpUrl(content);
  }
}
